import { useState } from "react";
import reportlhImg from "../../assets/reprtlh.png"
import singlebulk from "../../assets/singlebulk.png"
import managelh from "../../assets/managelh.png"
import exceptionImg from "../../assets/eception.png"
export function renderreportLH() {
  return <ReportLHComponent />;
}

function ReportLHComponent() {
  const [zoomImage, setZoomImage] = useState(null);

  return (
  <div className="text-slate-900 dark:text-slate-100 antialiased selection:bg-primary selection:text-white transition-colors duration-300">
      {/* Main Content */}
      <main className="py-10"> 
        <div className="mx-auto">
          {/* Breadcrumbs */}
          <div className="flex flex-wrap items-center gap-2 mb-6 text-sm">
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Netraa LH</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <a className="text-slate-500 dark:text-[#90a9cb] hover:text-primary transition-colors" href="#">Product Capabilities</a>
              <span className="text-slate-400 dark:text-slate-600">/</span>
              <span className="text-primary font-medium">Reports</span>
            </div>

          {/* Page Header */}
          <div className="mb-12 border-b border-border-light dark:border-border-dark pb-8">
            <h1 className="text-5xl lg:text-5xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Reports</h1>
            <p className="text-lg leading-relaxed text-slate-600 dark:text-slate-300">
              Generate, manage, and distribute mission-critical observability insights. This guide details how to track errors, manage maintenance exceptions, and automate report delivery to stakeholders.
            </p>
          </div>

          {/* 8.1 Errors Overview */}
          <section className="mb-16 scroll-mt-24" id="errors-overview">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Errors Overview</h2>
            </div>

            <div className="prose prose-slate dark:prose-invert max-w-none mb-8">
              <p className="text-slate-600 dark:text-slate-300 mb-4">
                The Errors Overview dashboard provides a granular look at system failures. Utilize the calendar widget to filter incidents by date range. The interactive data table presents critical telemetry including:
              </p>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm font-medium text-slate-700 dark:text-slate-300 list-none pl-0">
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Monitor Name</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Page Name</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Error / Description</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Start / End Time</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Downtime Duration</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Created On</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Current Status</li>
                <li className="flex items-center gap-2"><span className="material-symbols-outlined text-primary text-base">check_circle</span> Error Type</li>
              </ul>
            </div>

            {/* UI Snippet Placeholder */}

      <img
        src={reportlhImg}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(reportlhImg)}
      />

          </section>

          {/* 8.2 Add Exception */}
          <section className="mb-16 scroll-mt-24" id="adding-exceptions">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Add Maintenance Exception</h2>
            </div>

            <p className="text-slate-600 dark:text-slate-300 mb-6">
              Scheduled maintenance should not negatively impact your uptime statistics. Use the Exception Manager to exclude specific time windows from availability reports.
            </p>

            <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 border border-border-light dark:border-border-dark mb-8">
              <h3 className="text-lg font-bold mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">list_alt</span> Steps to Add Exception
              </h3>

              <ol className="relative border-slate-200 dark:border-slate-700 ml-3 space-y-6">
                {[
                  "Select the target Monitor from the dropdown.",
                  "Specify the Page affected.",
                  "Choose the Exception Type (e.g., Scheduled Maintenance, Upgrade).",
                  "Enter a brief Description for audit trails.",
                  "Set the Start Time and End Time.",
                  "Click Save to apply immediately.",
                  "Use Reset to clear the form if needed.",
                ].map((step, i) => (
                  <li key={i} className="mb-2 ml-6">
                    <span className="absolute flex items-center justify-center w-6 h-6 bg-slate-100 rounded-full -left-3 ring-8 dark:bg-slate-800">
                      <span className="text-xs font-bold">{i + 1}</span>
                    </span>
                    <span className="text-slate-700 dark:text-slate-300">{step}</span>
                  </li>
                ))}
              </ol>
            </div>

            <h3 className="text-xl font-bold font-display text-slate-900 dark:text-white mb-4 scroll-mt-24" id="bulk-uploads">Bulk Uploads</h3>
            <p className="text-slate-600 dark:text-slate-300 mb-4">
              For large-scale maintenance events affecting multiple monitors, utilize the bulk upload feature. The system accepts standard spreadsheet formats including <code className="bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-sm font-mono text-primary">.xls</code>, <code className="bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-sm font-mono text-primary">.xlsx</code>, and <code className="bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-sm font-mono text-primary">.ods</code>.
            </p>

            {/* UI Snippet Placeholder */}

      <img
        src={exceptionImg}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(exceptionImg)}
      />

          </section>

          {/* 8.3 Reports */}
          <section className="mb-16 scroll-mt-24" id="single-bulk-reports">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Reports (Single &amp; Bulk)</h2>
            </div>

            <p className="text-slate-600 dark:text-slate-300 mb-6">
              Generate comprehensive performance data snapshots. The reporting engine supports both individual monitor analysis and bulk export for ecosystem-wide audits.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              <div>
                <h4 className="font-bold text-slate-900 dark:text-white mb-4">Configuration Steps</h4>
                <ul className="space-y-4 text-slate-600 dark:text-slate-300 text-sm">
                  <li className="flex gap-3">
                    <span className="material-symbols-outlined text-primary shrink-0">filter_1</span>
                    <span><strong>Monitor Selection:</strong> Choose specific endpoints or groups.</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="material-symbols-outlined text-primary shrink-0">filter_2</span>
                    <span><strong>Report Type:</strong> Toggle between Single (detailed) or Bulk (summary).</span>
                  </li>
                  <li className="flex gap-3">
                    <span className="material-symbols-outlined text-primary shrink-0">filter_3</span>
                    <span><strong>Frequency:</strong> Set automated generation (Daily, Weekly, Monthly).</span>
                  </li>
                </ul>

                <div className="mt-6 p-4 rounded-lg bg-orange-50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-900/30">
                  <div className="flex items-start gap-3">
                    <span className="material-symbols-outlined text-primary">info</span>
                    <div>
                      <p className="text-sm font-bold text-slate-900 dark:text-white">Output &amp; Sharing</p>
                      <p className="text-xs text-slate-600 dark:text-slate-400 mt-1">Reports are generated in CSV format for maximum compatibility. Use the 'Actions' menu to <span className="font-mono text-primary">Download</span> locally or <span className="font-mono text-primary">Send</span> via email directly.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div className="p-4 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center">
                  <span className="material-symbols-outlined text-3xl text-primary mb-2">tune</span>
                  <span className="text-xs font-bold uppercase tracking-wide text-slate-500">Flexible Options</span>
                </div>
                <div className="p-4 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center">
                  <span className="material-symbols-outlined text-3xl text-primary mb-2">schedule</span>
                  <span className="text-xs font-bold uppercase tracking-wide text-slate-500">Custom Frequency</span>
                </div>
                <div className="p-4 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center">
                  <span className="material-symbols-outlined text-3xl text-primary mb-2">share</span>
                  <span className="text-xs font-bold uppercase tracking-wide text-slate-500">Easy Sharing</span>
                </div>
                <div className="p-4 rounded-xl bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark flex flex-col justify-center items-center text-center">
                  <span className="material-symbols-outlined text-3xl text-primary mb-2">folder_zip</span>
                  <span className="text-xs font-bold uppercase tracking-wide text-slate-500">Efficient Archiving</span>
                </div>
              </div>
            </div>

            {/* UI Snippet Placeholder */}

      <img
        src={singlebulk}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(singlebulk)}
      />
              
          </section>

          {/* 8.4 Manage (Email Configuration) */}
          <section className="mb-16 scroll-mt-24" id="email-configuration">
            <div className="flex items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold font-display text-slate-900 dark:text-white">Manage (Email Configuration)</h2>
            </div>

            <p className="text-slate-600 dark:text-slate-300 mb-6">
              Ensure stakeholders are kept in the loop by configuring automated email distribution lists for generated reports.
            </p>

            <div className="bg-slate-900 rounded-xl p-6 md:p-8 text-white mb-8 relative overflow-hidden">
              {/* Decorative bg */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl -mr-16 -mt-16" />
              <div className="relative z-10 grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-lg font-bold font-display mb-4">Configuration Workflow</h3>
                  <ul className="space-y-3 text-sm text-slate-300">
                    <li className="flex gap-2"><span className="material-symbols-outlined text-primary text-sm pt-1">arrow_forward_ios</span> Select specific Monitors.</li>
                    <li className="flex gap-2"><span className="material-symbols-outlined text-primary text-sm pt-1">arrow_forward_ios</span> Populate To/Cc fields with valid email addresses.</li>
                    <li className="flex gap-2"><span className="material-symbols-outlined text-primary text-sm pt-1">arrow_forward_ios</span> Submit for Admin Approval.</li>
                  </ul>
                </div>

                <div className="bg-white/5 rounded-lg p-4 backdrop-blur-sm border border-white/10">
                  <div className="flex items-center gap-2 mb-2 text-primary">
                    <span className="material-symbols-outlined">security</span>
                    <span className="font-bold uppercase text-xs tracking-wider">Centralized Approval</span>
                  </div>
                  <p className="text-xs leading-relaxed text-slate-300">
                    For security compliance, all distribution list changes enter a <strong>'Pending Requests'</strong> queue. Only authorized Admins can finalize these updates, preventing unauthorized data leakage.
                  </p>
                </div>
              </div>
            </div>

      <img
        src={managelh}   // <-- replace with your image variable
        alt="Filter & Selection Controls"
        className="w-auto h-auto object-cover "
        onClick={() => setZoomImage(managelh)}
      />

          </section>
{zoomImage && (
  <div
    className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
    onClick={() => setZoomImage(null)}
  >
    <img
      src={zoomImage}
      alt="Zoomed Preview"
      className="max-w-[90vw] max-h-[90vh] rounded-xl shadow-2xl object-contain"
    />
  </div>
)}
        </div>
      </main>
    </div>
);
}